import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { ValidateTokenEmailTypes } from '../Types';

const machine = Machines.onValidateTokenEmail.machine;

export const validateTokenEmail = (
  params: ValidateTokenEmailTypes.ValidateTokenEmailServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { validateTokenEmail };
